import { Auth0Config } from '../types';

/**
 * Default Auth0 configuration from environment variables.
 * This function centralizes the configuration retrieval.
 */
export const getDefaultAuth0Config = (): Auth0Config => ({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    authorizationParams: {
        redirect_uri: `${window?.location.origin ?? ''}/organization/select`,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        scope: 'openid profile email',
    },
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
});

/**
 * Merges default configuration with overrides.
 * @param overrides - Partial configuration to override defaults
 * @returns Complete Auth0 configuration
 */
export const getAuth0Config = (
    overrides?: Partial<Auth0Config>,
): Auth0Config => {
    const defaultConfig = getDefaultAuth0Config();
    return { ...defaultConfig, ...overrides };
};
